/**
 * Mock Data: User Age Statistic
 * Mock data for user age distribution
 *
 * Corresponds to Postman endpoint: GET /product/api/v1/dashboard/demographics/age
 */

import type { AgeRangeData } from '../data/remote/response';

// Re-export types from response module for backward compatibility
export type { AgeRangeData, AgeDemographicsApiResponse } from '../data/remote/response';

// Legacy aliases for backward compatibility
export type UserAgeRange = AgeRangeData;
export interface UserAgeData {
  data: readonly AgeRangeData[];
}

export const mockUserAgeData: UserAgeData = {
  data: [
    { range: '17-25 Years', count: 250000, percentage: 25 },
    { range: '26-35 Years', count: 250000, percentage: 25 },
    { range: '36-45 Years', count: 250000, percentage: 25 },
    { range: '46-55 Years', count: 250000, percentage: 25 },
  ],
};

export const userAgeSegmentColors: readonly string[] = [
  '#000f3d',
  '#1f355f',
  '#cbd5e1',
  '#e5e7eb',
];
